/*
 * @Author: 任晓帅
 * @Contact: VX:ren18321147631
 * @Date: 2026-02-14 16:58:27
 * @Description: 不可进行二次销售
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import works from './modules/works'
import earnings from './modules/earnings'
import app from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    works,
    earnings,
    app
  },
  getters: {
    // 全局getters
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    visitedViews: state => state.app.visitedViews,
    cachedViews: state => state.app.cachedViews
  }
})